// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"806":"user","884":"admin","933":"auth"}[chunkId] || chunkId) + "-legacy." + {"50":"4cbd049b","484":"6023e934","607":"64923270","806":"01d22d2c","884":"83a449ed","933":"62eb7a28","943":"f8ef12dd"}[chunkId] + ".js";
};